module.exports = __webpack_public_path__ + "img/NHWBCarousel_park.7b9b2ae5.jpg";